var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"device-preview"},[_c('StatusTag',{staticClass:"is-pulled-right",attrs:{"device":_vm.device}}),_c('Subtitle',[_vm._v(_vm._s(_vm.device.name))]),_c('State',{attrs:{"device":_vm.device}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }